import React from 'react';
import Sidebar from '../components/Sidebar';

const MainLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Sidebar />

            {/* Main Content Area */}
            <main className="lg:ml-64 pt-16 lg:pt-0">
                <div className="p-4 md:p-6 lg:p-8">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default MainLayout;